import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // Greift auf den echten Error-Stack zu
    const chunk = error?.stack || error?.message || error;

    // An dein Backend / OpenObserve senden
    console.error( `${error?.message ?? 'Unknown Error'}: Captured Error Stack:`, chunk);
  }
}
